module.exports = __webpack_public_path__ + "img/BPLogo-01.c5aee95f.svg";